import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import PropTypes from 'prop-types';
import {
    FormControlLabel,
    Radio,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    '@global': {
        ul: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
        },
    },
    cardHeader: {
        backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    },
    lineOne: {
        backgroundColor: '#aadedede',
    },
    lineTwo: {
        backgroundColor: '#ffffff',
    },
    paddingZero: {
        padding: 0,
    },
    cardPricing: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
    },
    checkbox: {
        display: 'block',
        textAlign: 'center',
        backgroundColor:
        theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    },
    checkboxLable: {
        marginLeft: 0,
        marginRight: 0,
    },
    carBorder: {
        border: '1px solid #aadedede',
    },

}));
export default function Pricing(props) {
    const classes = useStyles();
    const intl = useIntl();
    const { tiers, handleOption } = props;
    const [data, setData] = useState([]);
    const [checkRadio, setCheckRadio] = useState({});
    const checkRadioDefault = (value) => {
        let temp = {};
        Object.keys(value).forEach((key) => {
            temp = { ...temp, [key]: false };
        });
        return temp;
    };

    useEffect(() => {
        if (!_.isEmpty(tiers)) {
            setData(Object.values(tiers).filter((x) => x.name));
        }
    }, [tiers]);

    useEffect(() => {
        if (!_.isEmpty(data)) {
            setCheckRadio(radioDefaultsValue);
        }
    }, [data]);

    const radioDefaultsValue = checkRadioDefault(data);
    const handleCheckRadio = (fields, value) => {
        setCheckRadio({ ...radioDefaultsValue, [fields]: value });
        handleOption(fields);
    };
    return (
        <Container maxWidth="md" component="main" style={{ padding: '0px' }}>
            <Grid container spacing={1} alignItems="flex-end" justify="center">
                {data.map((tier) => (
                    <Grid item key={tier.name} xs={12} md={data.length === 4 ? 6 : 12 / data.length}>
                        <Card className={classes.carBorder}>
                            <CardHeader
                                title={tier.name}
                                titleTypographyProps={{ align: 'center' }}
                                subheaderTypographyProps={{ align: 'center' }}
                                className={classes.cardHeader}
                            />
                            <CardContent className={classes.paddingZero}>
                                <ul className={classes.lineOne}>
                                    <Typography component="li" variant="subtitle1" align="center">
                                        {intl.formatMessage({ id: 'register.totalProduct' }, { numberProduct: tier.total_media })}
                                    </Typography>
                                </ul>
                                <ul className={classes.lineTwo}>
                                    <Typography component="li" variant="subtitle1" align="center">
                                        {intl.formatMessage({ id: 'register.image' }, { numberImage: tier.image })}
                                    </Typography>
                                </ul>
                                <ul className={classes.lineOne}>
                                    <Typography component="li" variant="subtitle1" align="center">
                                        {intl.formatMessage({ id: 'register.imageTitle' })}
                                    </Typography>
                                    <Typography component="li" align="center" style={{ fontSize: 14 }}>
                                        {intl.formatMessage({ id: 'register.noteImageTitle' })}
                                    </Typography>
                                </ul>
                                <ul className={classes.lineTwo}>
                                    <Typography component="li" variant="subtitle1" align="center">
                                        {intl.formatMessage({ id: 'register.audio' }, { numberAudio: tier.audio })}
                                    </Typography>
                                </ul>
                                <ul className={classes.lineOne}>
                                    <Typography component="li" variant="subtitle1" align="center">
                                        {intl.formatMessage({ id: 'register.video' }, { numberVideo: tier.video })}
                                    </Typography>
                                </ul>
                                <ul className={classes.lineTwo}>
                                    <Typography component="li" variant="subtitle1" align="center">
                                        {intl.formatMessage({ id: 'register.boothFee' }, { price: tier.price })}
                                    </Typography>
                                </ul>
                            </CardContent>
                            <CardActions className={classes.checkbox}>
                                <FormControlLabel
                                    className={classes.checkboxLable}
                                    control={(
                                        <Radio />
                                    )}
                                    checked={checkRadio[tier.type] || false}
                                    onChange={(e) => handleCheckRadio(`${tier.type}`, e.target.checked)}
                                />
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

Pricing.defaultProps = {
    tiers: {},
    handleOption: () => {},
};

Pricing.propTypes = {
    tiers: PropTypes.objectOf(PropTypes.object),
    handleOption: PropTypes.func,
};
